/**
 * @module productTypes
 * @description A list of productTypes
 */

export const productTypes = ['product', 'service', 'virtual'] as const;
export type ProductTypes = (typeof productTypes)[number];
